import React from 'react';
import styles from './VerifyEmailSpinner.module.scss';

function VerifyEmailSpinner() {
  return <div className={styles.spinner} role="status" aria-live="polite" aria-label="Please wait"></div>;
}

export default VerifyEmailSpinner;
